import jsCookie from 'js-cookie';

export const SEARCH_COOKIE = 'ha-trip-prst';

function getCookie(cookies, key) {
    let cookie;

    cookies.forEach((cook) => {
        const splittedCookie = cook.split('=');
        if (splittedCookie[0].trim() === key) {
            cookie = splittedCookie[1];
        }
    });

    return !cookie ? null : cookie;
}

function parseJSONCookie(cookie) {
    try {
        return JSON.parse(cookie.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent));
    } catch (e) {
        return null;
    }
}

export function getSearchCookie(cookies) {
    if (!cookies) {
        return null;
    }

    const parsedCookies = cookies.split(';');

    const searchCookie = getCookie(parsedCookies, SEARCH_COOKIE);

    return parseJSONCookie(searchCookie);
}

export function removeKeysFromSearchCookie(...keys) {
    const cookie = jsCookie.getJSON(SEARCH_COOKIE);

    if (!cookie) {
        return;
    }

    for (let key of keys) {
        delete cookie[key];
    }

    jsCookie.set(SEARCH_COOKIE, cookie);
}

export function removeDatesFromSearchCookie() {
    removeKeysFromSearchCookie('arrival', 'departure');
}
